import * as React from 'react';
import Button from '../../../components/Button';
import careteam from '../../../api/care-team';
import Popup from '../../../components/Modal';
import { Container, Label, Spacing, Warning } from './styles';

export default function ModalRequestAppointment(props){

    const [successVisible, setSuccessVisible] = React.useState(false);

    async function confirm(){
        await careteam.requestAppointment(props.providerId);
        setSuccessVisible(true);
    }

    function modalReturn(){
        setSuccessVisible(false); 
        props.return();
    }

    return (
        <Container>
            <Label>Confirm below and a member of out staff will contact you to schedule.</Label>
            <Spacing />
            <Button text='CONFIRM' onPress={confirm}/>
            <Spacing />
            <Warning>If You Have A Medical Emergency CALL 911 Immediately</Warning>
            <Popup  
                titleModal="Success"
                contentModal={
                    <Container>
                        <Label>Appointment Request Sent.</Label>
                        <Spacing />
                        <Button text='THANK YOU' onPress={modalReturn}/>
                        <Spacing />
                        <Warning>If You Have A Medical Emergency CALL 911 Immediately</Warning>
                    </Container>
                }
                onClose={modalReturn} 
                stateModal={successVisible} />
        </Container>
    )
}